export enum Status {
    ENABLED = 1,
    DISABLED
}
